module.exports = __webpack_public_path__ + "img/GQ.301132d3.svg";